import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11aecae9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications-vuew mt-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-md-stretch" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "p-5 rounded-3 mb-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 text-black" }, "Payment", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaddleComponent = _resolveComponent("PaddleComponent")!
  const _component_CancelModal = _resolveComponent("CancelModal")!
  const _component_UpgradeModal = _resolveComponent("UpgradeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_PaddleComponent, { onSetSelectedProductId: _ctx.setSelectedProductId }, null, 8, ["onSetSelectedProductId"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_CancelModal),
    _createVNode(_component_UpgradeModal, { productId: _ctx.selectedProductId }, null, 8, ["productId"])
  ]))
}